import React, { useEffect, useState } from "react";

function getTargetDate() {
  const stored = localStorage.getItem("mda_countdown_target");
  if (stored) return new Date(parseInt(stored, 10));
  const target = new Date();
  target.setDate(target.getDate() + 6);
  target.setHours(23, 59, 59);
  localStorage.setItem("mda_countdown_target", target.getTime().toString());
  return target;
}

export default function Countdown() {
  const [target] = useState(getTargetDate);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, target.getTime() - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hrs = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const min = Math.floor((diff / (1000 * 60)) % 60);
  const sec = Math.floor((diff / 1000) % 60);

  const cells = [
    { v: days, l: "giorni" },
    { v: hrs, l: "ore" },
    { v: min, l: "min" },
    { v: sec, l: "sec" },
  ];

  return (
    <div className="inline-flex items-center gap-2 text-white/70 text-xs">
      <span className="tracking-widest uppercase text-white/50">Promo termina in</span>
      <div className="flex items-center gap-1">
        {cells.map((c, i) => (
          <React.Fragment key={c.l}>
            <div className="bg-white/5 border border-white/10 rounded-md px-2 py-1 min-w-[36px] text-center">
              <span className="font-mono-label text-white text-sm font-medium">
                {String(c.v).padStart(2, "0")}
              </span>
            </div>
            {i < cells.length - 1 && <span className="text-white/30">:</span>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
